import { useTemplateRef as N, useId as K, ref as p, computed as _, watch as O, createElementBlock as m, openBlock as d, normalizeClass as g, createElementVNode as r, withDirectives as S, createBlock as R, createCommentVNode as y, unref as B, createVNode as h, withCtx as M, toDisplayString as v, Fragment as j, renderList as P, vShow as A } from "vue";
import $ from "../../../atoms/icon/icon-frame.vue.js";
import k from "../../../atoms/icon/icon.vue.js";
import { themeProp as G } from "../../../composables/useTheme.js";
import H from "../../tooltip/tooltip.vue.js";
/* empty css                     */
import J from "../../../_virtual/_plugin-vue_export-helper.js";
const Q = { class: "ds-form-attachment__input-container" }, U = ["for"], W = {
  key: 0,
  class: "ds-color-red"
}, X = ["id", "name", "multiple", "accept", "required"], Y = {
  "aria-live": "polite",
  class: "ds-form-attachment__file-container"
}, Z = ["title"], ee = { class: "ds-form-attachment__file-info ds-text-small" }, te = { key: 0 }, ae = ["aria-label", "onClick"], z = 25 * 1024 * 1024, re = /* @__PURE__ */ Object.assign({
  name: "DsFormAttachment",
  inheritAttrs: !1
}, {
  __name: "form-attachment",
  props: {
    ...G,
    label: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    extensions: {
      type: Array,
      required: !0
    },
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    multiple: {
      type: Boolean,
      required: !1,
      default: !0
    },
    info: {
      type: String,
      required: !0
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    sizeLimitExceededMessage: {
      type: String,
      required: !0
    },
    extensionNotValidMessage: {
      type: String,
      required: !0
    }
  },
  emits: ["value"],
  setup(s, { emit: w }) {
    const n = s, x = w, E = N("attachmentInput"), F = K(), o = p([]), i = p(n.hasError), c = p(n.errorMessage), D = _(() => o.value.length > 0), f = _(() => [...o.value]), L = _((e) => {
      let t = e;
      return t || (t = /* @__PURE__ */ new Set()), f.value.forEach((a) => {
        t.has(a.name) || t.add(a.name);
      }), t;
    }), C = (e) => {
      if (!e.target.files) return;
      const t = new DataTransfer();
      f.value.forEach((u) => {
        t.items.add(u);
      }), [...e.target.files].forEach((u) => {
        L.value.has(u.name) || t.items.add(u);
      }), E.value.files = t.files, o.value = t.files;
      const l = [...o.value];
      b(l) && (i.value = !1, c.value = "", x("value", l));
    }, I = (e) => {
      const t = new DataTransfer();
      f.value.forEach((l) => {
        l.name !== e.name && t.items.add(l);
      }), E.value.files = t.files, o.value = t.files;
      const a = [...o.value];
      b(a) && (i.value = !1, c.value = "", x("value", a));
    }, q = (e) => e < 1048576 ? (e / 1024).toFixed(2) + " KB" : (e / 1048576).toFixed(2) + " MB", T = (e) => {
      if (!e || !Array.isArray(e)) return;
      let t = 0;
      return e.forEach((a) => {
        t += a.size;
      }), !(t > z);
    }, V = (e) => {
      if (!n.extensions.length) return !0;
      if (!e || !Array.isArray(e)) return !1;
      let t = !0;
      for (const a of e) {
        const l = a.name.split(".").pop();
        if (l && (t = n.extensions.some((u) => u.includes(l)), !t))
          return !1;
      }
      return t;
    }, b = (e) => !e || !Array.isArray(e) ? !1 : T(e) ? V(e) ? !0 : (i.value = !0, c.value = `${n.extensionNotValidMessage} ${n.extensions}`, !1) : (i.value = !0, c.value = `${n.sizeLimitExceededMessage} ${q(z)}`, !1);
    return O(
      () => n.hasError,
      (e) => {
        i.value = e;
      }
    ), (e, t) => (d(), m("div", {
      class: g(["ds-form-attachment", `ds-form-attachment--${e.theme}`])
    }, [
      r("div", {
        class: g(["ds-form-attachment__field", {
          "ds-form-attachment__field--with-error": i.value
        }])
      }, [
        r("div", Q, [
          r("label", {
            for: `attachment-${B(F)}`,
            class: "ds-form-attachment__input-label ds-display-flex ds-align-items-center ds-padding-12"
          }, [
            h($, {
              size: "24",
              "align-y": "center",
              "aria-hidden": "true",
              class: g(["ds-padding-right-4", {
                "ds-color-black": i.value
              }])
            }, {
              default: M(() => [
                h(k, {
                  name: "plus-medium",
                  category: "interface"
                })
              ]),
              _: 1
            }, 8, ["class"]),
            r("span", null, v(s.label), 1),
            s.required ? (d(), m("span", W, " * ")) : y("", !0)
          ], 8, U),
          r("input", {
            id: `attachment-${B(F)}`,
            ref: "attachmentInput",
            type: "file",
            name: s.name,
            multiple: s.multiple,
            accept: s.extensions,
            required: s.required || null,
            class: "ds-sr-only",
            onChange: C
          }, null, 40, X),
          s.info ? (d(), R(H, {
            key: 0,
            class: "ds-form-attachment__tooltip",
            theme: "light",
            description: s.info
          }, null, 8, ["description"])) : y("", !0)
        ]),
        S(r("div", Y, [
          t[0] || (t[0] = r("div", {
            "aria-hidden": "true",
            class: "ds-form-attachment__container-divider"
          }, null, -1)),
          (d(!0), m(j, null, P(f.value, (a) => (d(), m("div", {
            key: a.name,
            class: "ds-form-attachment__file"
          }, [
            r("span", {
              title: a.name,
              class: "ds-form-attachment__file-name"
            }, v(a.name), 9, Z),
            r("div", ee, [
              a.size ? (d(), m("span", te, v(q(a.size)), 1)) : y("", !0),
              r("button", {
                type: "button",
                "aria-label": `Delete ${a.name}`,
                class: "ds-form-attachment__file-delete",
                onClick: () => I(a)
              }, [
                h($, {
                  size: "24",
                  "align-y": "center"
                }, {
                  default: M(() => [
                    h(k, {
                      category: "interface",
                      name: "cross-small"
                    })
                  ]),
                  _: 1
                })
              ], 8, ae)
            ])
          ]))), 128))
        ], 512), [
          [A, D.value]
        ])
      ], 2),
      S(r("p", {
        "aria-live": "polite",
        class: "ds-color-red-1700 ds-text-small"
      }, v(c.value), 513), [
        [A, i.value && c.value]
      ])
    ], 2));
  }
}), de = /* @__PURE__ */ J(re, [["__scopeId", "data-v-8baafb3c"]]);
export {
  de as default
};
